export default function ZikZakTik() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M15.125 8.75L9.62497 14L6.875 11.375M4.10571 17.8943C3.24283 17.0314 3.81514 15.2198 3.37595 14.1584C2.92066 13.058 1.25 12.1723 1.25 11C1.25 9.82761 2.92067 8.942 3.37595 7.84164C3.81515 6.78015 3.24283 4.96858 4.10571 4.10571C4.96858 3.24283 6.78016 3.81514 7.84165 3.37595C8.94203 2.92066 9.82766 1.25 11 1.25C12.1724 1.25 13.058 2.92067 14.1584 3.37595C15.2199 3.81515 17.0314 3.24283 17.8943 4.10571C18.7572 4.96858 18.1849 6.78016 18.6241 7.84165C19.0793 8.94203 20.75 9.82766 20.75 11C20.75 12.1724 19.0793 13.058 18.624 14.1584C18.1848 15.2199 18.7572 17.0314 17.8943 17.8943C17.0314 18.7572 15.2198 18.1849 14.1584 18.6241C13.058 19.0793 12.1723 20.75 11 20.75C9.82761 20.75 8.942 19.0793 7.84164 18.624C6.78015 18.1848 4.96858 18.7572 4.10571 17.8943Z"
        stroke="#DC3545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
